import React from "react";

const RoleTutor = () => (
  <section className="w-full bg-light-6 py-12 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <h3 className="text-title font-bold text-dark-1 mb-6">Le rôle du tuteur</h3>
      <ul className="space-y-3 text-normal text-light-1 text-left md:text-center">
        <li>👉 <strong>Accompagner</strong> des jeunes et des apprenants dans leurs projets.</li>
        <li>👉 <strong>Partager</strong> ses connaissances techniques ou créatives.</li>
        <li>👉 <strong>Encourager</strong> curiosité, autonomie et esprit maker.</li>
        <li>👉 <strong>Participer</strong> à des ateliers, parcours ou projets collaboratifs.</li>
      </ul>
      <p className="mt-4 text-dark-3">
        Chaque tuteur choisit son <strong>niveau d’engagement</strong> : sessions ponctuelles, suivi continu, ateliers, stages d’été…
      </p>
    </div>
  </section>
);

export default RoleTutor;
